import ClassTimes from './class_times';
import classTimesList from '../templates/class_time_list.mustache';
import MicroModal from 'micromodal';
import sectionDetail from '../templates/section_detail.mustache';
import weeklySummary from '../templates/class_time_summary.mustache';
import timezone from 'mex_components/app/scripts/date/timezone';
import toggleClass from 'mex_components/app/scripts/elements/toggleClass';

/**
 * Converts date string to unix time for comparison
 *
 * @param {String} date Date string, eg. "2021-07-19T20:00:00Z/PT1H"
 * @param {Integer} offset Offset to add to the date in minutes
 *   (eg. if passing start time, need to add duration to calculate end time)
 *
 * @returns unix time, eg. '1631221200000'
 */
 export const convertTime = (date, offset = 0) => {
  if (!date) return;
  date = date.split('/')[0];
  return new Date(date).getTime() + offset * 60000;
};

export function condensedClassSummaries(classTimes, isOffer = false) {
  const tz = timezone.shorterName();
  Array.from(classTimes).forEach((el) => {
    const elementId = el.dataset?.id;
    if (elementId) {
      const data = window.vt.sections[elementId];
      const classData = new ClassTimes(data.meeting_schedule);
      data.weekly = classData.weekly();
      data.timezone = tz;
      if (!isOffer) {
        el.innerHTML = weeklySummary(classData);
      }
    }
  });
}

export const showSectionDetail = (id) => {
  const data = window.vt.sections[id];
  const detailSection = document.getElementById('section-detail-content');
  if (!data || !detailSection) {
    return;
  }
  detailSection.innerHTML = sectionDetail(data);
  //capture our scroll position because showing the modal causes us to lose it
  document.getElementById('section_detail_modal').dataset.scrollY = window.scrollY;
  MicroModal.show('section_detail_modal', {
    disableScroll: true,
    openClass: 'js-micromodal--open',
    onShow: () => {
      // this is needed to fix the positioning issue caused by the
      // translateX rule on the nav component
      document.documentElement.classList.add('html--micromodal-open');
    },
    onClose: (modal) => {
      // this is needed to prevent the click from propagating and triggering
      // the click on the element underneath which opens a new tab
      event.preventDefault();
      event.stopPropagation();
      document.documentElement.classList.remove('html--micromodal-open');
      // return to our original scroll position
      window.scrollTo(0, modal.dataset.scrollY);
    }
  });
};

export function classSummaries() {
  Array.from(document.getElementsByClassName('class-times-list')).forEach(
    (el) => {
      const data = window.vt.sections[el.dataset.id];
      el.innerHTML = classTimesList(data);
    }
  );
}

function updateInnertext(target) {
  if (target.innerText == 'View details') {
    target.innerText = 'Hide details';
  } else if (target.innerText == 'Hide details') {
    target.innerText = 'View details';
  }
}

export function detailsSetUp(target, mediaQuery, className) {
  if (target.classList.contains('js-view-details')) {
    if (mediaQuery.matches) {
      const parent = target.closest(className);
      const divToShow = parent && parent.querySelector(`${className}--expanded`);
      updateInnertext(target);
      toggleClass(divToShow, 'js-expanded-section--expanded');
    } else {
      showSectionDetail(target.dataset.id);
    }
  }
}
